import { useEffect, useState } from 'react';
import { ConfigProvider, Layout, Tabs, Button, Typography, Select, Space, theme, Spin } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import keycloak from './keycloak';
import deDE from 'antd/locale/de_DE';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import ProductsTab from './components/ProductsTab';
import CategoriesTab from './components/CategoriesTab';
import { api } from './api';
import { useUrlParam } from './hooks/useUrlParam';
import './App.css';

dayjs.locale('de');

const { Header, Content } = Layout;
const { Title } = Typography;

export default function App() {
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useUrlParam('store');
  const [activeTab, setActiveTab] = useUrlParam('tab', 'products');
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    Promise.all([
      api.stores.list(),
      api.meta.productTypes(),
      api.meta.properties(),
      api.meta.units(),
    ]).then(([storeList, productTypes, properties, units]) => {
      setStores(storeList);
      const urlStore = new URLSearchParams(window.location.search).get('store');
      if (!urlStore && storeList.length === 1) {
        setSelectedStore(storeList[0].id);
      } else if (urlStore && !storeList.some(s => s.id === urlStore)) {
        setSelectedStore(null);
      }
      setMeta({ productTypes, properties, units });
    });
  }, [setSelectedStore]);

  const tabs = selectedStore && meta
    ? [
        { key: 'products',   label: 'Produkte',    children: <ProductsTab   storeId={selectedStore} meta={meta} /> },
        { key: 'categories', label: 'Kategorien',  children: <CategoriesTab storeId={selectedStore} meta={meta} /> },
      ]
    : [];

  return (
    <ConfigProvider
      locale={deDE}
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary:        '#a07838',
          colorLink:           '#a07838',
          colorBgLayout:       '#f5ede0',
          colorBgContainer:    '#ffffff',
          colorBorder:         '#e8d5b0',
          colorTextSecondary:  '#8a6a40',
          borderRadius:        6,
        },
      }}
    >
      <Layout style={{ minHeight: '100vh', background: '#f5ede0' }}>
        <Header style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 24px', background: '#7a5828',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src="/logo192.png" alt="Fair Products" style={{ width: 32, height: 32, borderRadius: 6, display: 'block' }} />
            <Title level={4} style={{ color: '#fff', margin: 0, lineHeight: 1 }}>Fair Products</Title>
          </div>
          <Space>
            <Select
              placeholder="Store wählen…"
              style={{ width: 200, background: '#fff', borderRadius: 6 }}
              value={selectedStore}
              onChange={setSelectedStore}
              options={stores.map(s => ({ value: s.id, label: s.name }))}
              variant="outlined"
            />
            <Button ghost icon={<LogoutOutlined />} onClick={() => keycloak.logout()}
              style={{ borderColor: '#fff', color: '#fff' }}>
              Abmelden
            </Button>
          </Space>
        </Header>
        <Content style={{ padding: '24px', maxWidth: 1400, margin: '0 auto', width: '100%' }}>
          {!meta ? (
            <div style={{ textAlign: 'center', padding: 80 }}><Spin size="large" /></div>
          ) : !selectedStore ? (
            <div style={{ textAlign: 'center', padding: 80, color: '#8a6a40' }}>
              Bitte einen Store auswählen.
            </div>
          ) : (
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              items={tabs}
              size="large"
              style={{ background: '#ffffff', borderRadius: 8, padding: '0 16px 16px',
                       border: '1px solid #e8d5b0' }}
            />
          )}
        </Content>
      </Layout>
    </ConfigProvider>
  );
}
